<template >
  <!-- /https://vuetifyjs.com/en/components/text-fields/ -->
  <v-col :cols="formDetail.cols">
  <v-text-field
    :name="index"
    :class="formDetail.class"
    type="date"
    :label="formDetail.title"
    v-model="dateValue"
    :rules="[rulesForm.required]"
  >
    <template v-slot:append>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>
  </v-text-field>
  </v-col>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail, props.index);

let dateValue = ref(props.model[props.index] ? props.model[props.index] : "");
</script>